/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_SubtitlesInputs */

const en_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Subtitles`)
};

const fr_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier les sous-titres`)
};

const de_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel bearbeiten`)
};

const it_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica sottotitoli`)
};

const ru_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать субтитры`)
};

const es_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar subtítulos`)
};

const zh_cn2_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑字幕`)
};

const ja_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕を編集する`)
};

const hi_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक संपादित करें`)
};

const pt_pt2_edit_subtitles = /** @type {(inputs: Edit_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar legendas`)
};

/**
* | output |
* | --- |
* | "Edit Subtitles" |
*
* @param {Edit_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_subtitles = /** @type {((inputs?: Edit_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_subtitles(inputs)
	if (locale === "de") return de_edit_subtitles(inputs)
	if (locale === "it") return it_edit_subtitles(inputs)
	if (locale === "ru") return ru_edit_subtitles(inputs)
	if (locale === "es") return es_edit_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_subtitles(inputs)
	if (locale === "ja") return ja_edit_subtitles(inputs)
	if (locale === "hi") return hi_edit_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_subtitles(inputs)
	return en_edit_subtitles(inputs)
});